module.exports = __webpack_public_path__ + "img/MamasBrille.184649fe.jpg";